<template>
    <div class="relation_wrap">
        <div class="titel">北京云赋网络科技有限公司</div>
        <img src="../../../static/images/card.png" alt="" class="card">
        <div class="way">
            <div class="wayitem location_wrap">
                <div class="location">
                    <img src="../../../static/images/location.png" alt="">
                    <p>北京市朝阳区常营乡管庄路150号院1号楼四层0404号</p>
                </div>
            </div>
            <div class="wayitem mailbox_wrap">
                <div class="mailbox">
                    <img src="../../../static/images/mailbox.png" alt="">
                    <p>linxuan@ecareyun.com</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "relation"
}
</script>

<style lang="scss">
@import '../../assets/css/style.scss';
.relation_wrap{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: url("/static/images/guanyu.png") no-repeat center;
    .way{
        width: 100%;
        margin-top: 80px;
        display: flex;
        .wayitem{
            flex: 1;
        }
        .mailbox_wrap{
            .mailbox{
                width: 200px;
                margin-left: 190px;
                img{
                    width: 34px;
                    height: 27px;
                    display: block;
                    margin: 0 auto;
                    margin-bottom: 20px;
                }
                p{
                    font-size: 18px;
                    font-weight: 400;
                    color: #FFFFFF;
                    text-align: center;
                }
            }
        }
        .location_wrap{
            .location{
                width: 440px;
                float: right;
                margin-right: 100px;
                img{
                    width: 30px;
                    height: 37px;
                    display: block;
                    margin: 0 auto;
                    margin-bottom: 20px;
                }
                p{
                    font-size: 18px;
                    font-weight: 400;
                    color: #FFFFFF;
                    text-align: center;
                }
            }
        }
    }
    .titel{
        margin-top: 400px;
        margin-bottom: 20px;
        font-size: 20px;
        font-weight: 400;
        color: #FFFFFF;
        text-align: center;
    }
    .card{
        width: 120px;
        height: 120px;
        margin: 0 auto;
        display: block;
        background: #fff;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/relationModel/index.vue